import * as React from "react";
import { Component } from "react";
import { Button, FormGroup, Table } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import LoadingStatus from "src/components/common/LoadingStatus";
import "src/css/components/projects/project/statements/advanced/servicecharges.css";
import { TIMEOUT } from "src/global";
import { IServiceCharge, IServiceChargesProps, IServiceChargesState } from "./interfaces";
import ServiceChargeLargeRow from "./ServiceChargeLargeRow";
import ServiceChargeSmallRow from "./ServiceChargeSmallRow";

export default class ServiceCharges extends Component<IServiceChargesProps, IServiceChargesState> {
  public constructor(props: IServiceChargesProps) {
    super(props);

    this.state = { loading: true, serviceCharges: [] };

    this.addServiceCharge = this.addServiceCharge.bind(this);
    this.deleteServiceCharge = this.deleteServiceCharge.bind(this);

    this.handleSCDescriptionChanged = this.handleSCDescriptionChanged.bind(this);
    this.handleSCValueChanged = this.handleSCValueChanged.bind(this);
    this.handleSCUnitChanged = this.handleSCUnitChanged.bind(this);
    this.handleSCRateChanged = this.handleSCRateChanged.bind(this);
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({
        loading: false,
        serviceCharges: this.props.serviceCharges,
      });
    }, TIMEOUT);
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset className="fieldset-left-right">
          <legend>Service Charges</legend>
          <LoadingStatus width={25} height={25} singular={true} />
        </fieldset>
      );
    }

    const windowWidth = window.screen.availWidth;
    const cutOff = 768;

    const hasPriorStatement =
      this.props.match.params.id !== undefined && this.props.match.params.priorId !== undefined;

    let totalServiceCharges: number = 0;
    this.props.serviceCharges.forEach(serviceCharge => {
      totalServiceCharges += serviceCharge.totalCharge;
    });

    return (
      <fieldset className="fieldset-left-right">
        <legend>{this.props.title}</legend>
        <Table condensed={true} striped={false} bordered={false}>
          <thead>
            <tr>
              <th id="serviceChargeHeader" style={{ textAlign: "left" }}>
                <Button bsSize="small" bsStyle="primary" onClick={this.addServiceCharge}>
                  Add Service Charge
                </Button>
              </th>
              {!this.props.needsSaving &&
              hasPriorStatement &&
              this.props.serviceCharges.length === 0 ? (
                <th style={{ textAlign: "left" }}>
                  <Button
                    bsSize="small"
                    bsStyle="warning"
                    onClick={this.props.copyPriorServiceCharges}
                  >
                    Copy from Last Statement
                  </Button>
                </th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {this.props.serviceCharges.map((serviceCharge, index) =>
              windowWidth <= cutOff ? (
                // <Form id="serviceChargeSmallRow" horizontal={true}>
                <ServiceChargeSmallRow
                  serviceCharge={serviceCharge}
                  deleteServiceCharge={this.deleteServiceCharge}
                  index={index}
                  descriptionChanged={this.handleSCDescriptionChanged}
                  valueChanged={this.handleSCValueChanged}
                  unitChanged={this.handleSCUnitChanged}
                  rateChanged={this.handleSCRateChanged}
                />
              ) : (
                // </Form>
                // <Form inline={true}>
                <ServiceChargeLargeRow
                  serviceCharge={serviceCharge}
                  deleteServiceCharge={this.deleteServiceCharge}
                  index={index}
                  descriptionChanged={this.handleSCDescriptionChanged}
                  valueChanged={this.handleSCValueChanged}
                  unitChanged={this.handleSCUnitChanged}
                  rateChanged={this.handleSCRateChanged}
                />
                // </Form>
              )
            )}
          </tbody>
          {this.props.serviceCharges.length > 0 && windowWidth > cutOff ? (
            <tfoot>
              <tr>
                <td style={{ verticalAlign: "middle", textAlign: "right" }} colSpan={4}>
                  Total Charges:
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  <FormGroup bsSize="small" controlId="totalCharge">
                    <CurrencyInput
                      className="servicecharge-input form-control input-sm"
                      id="servicecharge_totalCharge"
                      inputType="text"
                      value={totalServiceCharges}
                      prefix={"$"}
                      precision={2}
                      allowNegative={true}
                      tabIndex={-1}
                      selectAllOnFocus={false}
                    />
                  </FormGroup>
                </td>
              </tr>
            </tfoot>
          ) : null}
        </Table>
      </fieldset>
    );
  }

  private addServiceCharge(e: any) {
    e.preventDefault();
    this.props.addServiceCharge();
  }
  private deleteServiceCharge(serviceCharge: IServiceCharge) {
    this.props.deleteServiceCharge(serviceCharge);
  }
  private handleSCDescriptionChanged(value: any, index: number) {
    this.props.serviceCharges[index].description = value;
    this.props.updateServiceCharge(this.props.serviceCharges[index]);
  }
  private handleSCValueChanged(value: any, index: number) {
    this.props.serviceCharges[index].value = Number(value);
    this.props.updateServiceCharge(this.props.serviceCharges[index]);
  }
  private handleSCUnitChanged(value: any, index: number) {
    this.props.serviceCharges[index].unit = value;
    this.props.updateServiceCharge(this.props.serviceCharges[index]);
  }
  private handleSCRateChanged(value: any, index: number) {
    this.props.serviceCharges[index].rate = Number(value);
    this.props.updateServiceCharge(this.props.serviceCharges[index]);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/ServiceCharges.tsx